export default __webpack_public_path__ + "static/media/word.a0873456.png";